import styles from './ALayout.module.css'

import { Link, Outlet } from "react-router-dom"
import ANav from "../admin/common/ANav"
import AFooter from "../admin/common/AFooter"
// Helmet
import { Helmet } from 'react-helmet-async';
import { useSelector } from 'react-redux';
import ALeftMenu from './common/ALeftMenu';


const VLayout = () => {
    const isDefaultThemeColor = useSelector(state => state.helmet.theme_color.isDefault);
    const defaultThemeColor = useSelector(state => state.helmet.theme_color.defaultColor);
    const newThemeColor = useSelector(state => state.helmet.theme_color.newColor);

    const content = (
        <>
            {isDefaultThemeColor
                ?   <Helmet>
                    <meta name="theme-color" content={defaultThemeColor} />
                    </Helmet>
                : <Helmet>
                        <meta name="theme-color" content={newThemeColor} />
                    </Helmet>
            }
        
            <div className={styles.v_layout}>
                    <ANav />
                    <section className={styles.block_container}>
                        <div className={styles.block_left}>
                            <ALeftMenu />
                        </div>
                        <div className={styles.block_main}>
                            <Outlet />
                        </div>
                    </section>
                    
                    <AFooter />
                    <div className={styles.allRightsDevelopedBy}>
                        <p className={styles.developedBy}>Разработано <Link to='https://shakeshev.com'>www.shakeshev.com</Link></p>
                    </div>
            </div>
        </>
    )
    return content
}

export default VLayout